export function logError(error: Error, { fatal = true }: { fatal?: boolean } = {}) {
	if (fatal) {
		console.error(error.message, error);
		if ('digest' in error) console.log(`Error digest: ${error.digest}`);
		console.log(`Error name: ${error.name}`);
		console.log(`Error stack: ${error.stack}`);
		console.log(`Error cause: ${error.cause}`);

		return;
	}

	console.info(error.message, error);
	if ('digest' in error) console.info(`Error digest: ${error.digest}`);
	console.info(`Error name: ${error.name}`);
}
